import React from "react"

import {IonButton, IonIcon} from "@ionic/react"
import {shieldCheckmarkOutline, shieldCheckmarkSharp} from "ionicons/icons"

import User from "@customTypes/User"
import {useHistory} from "react-router";

interface props {
    item: User
}

const ListItemButtonLockingSystemPermissions: React.FC<props> = ({item}) => {

    const history = useHistory()

    const goToSegment = (ev: any, itemId: number, segment: string) => {
        ev.preventDefault()
        ev.stopPropagation()

        history.push('/users/' + itemId + '/' + segment)
    }

    return (
        <IonButton color="medium" fill="clear" size="large"
                   onClick={ (ev) =>
                       goToSegment(ev, item.id, 'locking-system-permissions') }
                   style={{ 'minWidth': '80px', 'fontSize': '1rem' }}>
            <IonIcon slot="start" ios={shieldCheckmarkOutline} md={shieldCheckmarkSharp} />
            {item.lockingSystemPermissions?.length || '-'}
        </IonButton>
    )
}

export default ListItemButtonLockingSystemPermissions